var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-lg",class:{ 'border-b border-neutral-lightest' : ! _vm.isLast }},[_c('checkbox-input',{attrs:{"name":"field_technicians[]","value":_vm.user.id},model:{value:(_vm.isChecked),callback:function ($$v) {_vm.isChecked=$$v},expression:"isChecked"}},[_vm._v("\n        "+_vm._s(_vm.user.name)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }